import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import UAParser from "ua-parser-js";
import { ReactComponent as AppleIcon } from "svg/apple.svg";
import { ReactComponent as CloseIcon } from "svg/x.svg";

const parser = new UAParser();
const os = parser.getOS();
const isMac = os?.name?.match(/mac/gi);

export default function MacAppNotification() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const macAppNotification = JSON.parse(localStorage.getItem("mac-app-notification"));

    let timer = undefined;
    if (!macAppNotification) {
      timer = setTimeout(() => {
        setShow(true);
      }, 5000);
    }

    return () => {
      timer && clearTimeout(timer);
    };
  }, []);

  const onClose = () => {
    localStorage.setItem("mac-app-notification", true);
    setShow(false);
  };

  if (!isMac || !show) {
    return null;
  }

  return (
    <div className="mac-app-notification">
      {/* <div className="overlay"></div> */}
      <div className="popup">
        <AppleIcon className="apple-icon" />
        <CloseIcon className="close-icon" onClick={onClose} />
        <div>
          <div>
            <strong>The app now is available for Mac</strong>
          </div>
          <div style={{ marginTop: 10, marginBottom: 14 }}>
            <span>Auto-import runes, champ select scouting, and more.</span>
          </div>
          <Link className="btn-blue btn-blue_hover" to="/app?utm_source=uggmacnotif" onClick={onClose}>
            See Features
          </Link>
        </div>
      </div>
    </div>
  );
}
